export const SET_FLAGGED_QUESTION = "feedback/SET_FLAGGED_QUESTION"
export const SET_UNFLAGGED_QUESTION = "feedback/SET_UNFLAGGED_QUESTION"
export const SET_QUESTION_COMPLAINT = "feedback/SET_QUESTION_COMPLAINT"
export const SET_FLAG = "feedback/SET_FLAG"
export const SET_FLAG_FEEDBACK = "feedback/SET_FLAG_FEEDBACK"
export const SET_EXPLANATION = "feedback/SET_EXPLANATION"
export const FLAG_ITEM = "feedback/FLAG_ITEM"
export const UNFLAG_ITEM = "feedback/UNFLAG_ITEM"
export const SET_VISIT_FEEDBACK_OPEN = "feedback/SET_VISIT_FEEDBACK_OPEN"
export const SET_DIAGNOSIS_TAG = "feedback/SET_DIAGNOSIS_TAG"
export const SET_DOCTOR_TAG = "feedback/SET_DOCTOR_TAG"
export const SET_CUSTOM_SUBMITTED = "feedback/SHOW_CUSTOM"
export const SET_CUSTOM_TAG = "feedback/SET_CUSTOM_TAG"
export const SET_DIAGNOSIS_QUERY = "feedback/SET_DIAGNOSIS_QUERY"
export const SET_DIAGNOSIS_SUGGESTIONS = "feedback/SET_DIAGNOSIS_SUGGESTIONS"
export const INCREMENT_DIAGNOSIS_SUGGESTION =
  "feedback/INCREMENT_DIAGNOSIS_SUGGESTION"
export const DECREMENT_DIAGNOSIS_SUGGESTION =
  "feedback/DECREMENT_DIAGNOSIS_SUGGESTION"
export const SET_TAGGING_FINISHED = "feedback/SET_TAGGING_FINISHED"
export const SET_FOLLOW_UP_OPTIONS = "feedback/SET_FOLLOW_UP_OPTIONS"
export const SET_FOLLOW_UP_RESPONSE = "feedback/SET_FOLLOW_UP_RESPONSE"
export const SET_FOLLOW_UP_TEXT = "feedback/SET_FOLLOW_UP_TEXT"
export const SET_FOLLOW_UP_SUBMITTED = "feedback/SET_FOLLOW_UP_SUBMITTED"
export const SET_GET_NPS_FEEDBACK = "feedback/SET_GET_NPS_FEEDBACK"
export const SET_SHOW_NPS_CARD = "feedback/SET_SHOW_NPS_CARD"
export const SET_NPS_SUBMITTED = "feedback/SET_NPS_SUBMITTED"
export const SUBMIT_NPS_SCORE = "feedback/SUBMIT_NPS_SCORE"
export const SUBMIT_NPS_COMMENT = "feedback/SUBMIT_NPS_COMMENT"
export const SET_SHOW_POST_INTENT_POPUP = "feedback/SET_SHOW_POST_INTENT_POPUP"
export const SET_SPECIALIST_OPTIONS = "feedback/SET_SPECIALIST_OPTIONS"
export const SET_SPECIALIST_SUGGESTION = "feedback/SET_SPECIALIST_SUGGESTION"
export const SET_DIAGNOSIS_CONCERN = "feedback/SET_DIAGNOSIS_CONCERN"



// WEBPACK FOOTER //
// ./assets/feedback/actionTypes.js